export function normalize(value:number, min:number, max:number){
  if(max == min) return min;
  return (value - min) / (max - min);
}